import { get } from "lodash";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { HOT_LIST } from "utils/constants";

const MINUTE_MS = 60 * 1000;
const HOUR_MINUTES = 60;
const DAY_MINUTES = 24 * HOUR_MINUTES;

const latestSignal = (project) => {
  const details = get(project, "heatDetails") || {};
  const candidates = [
    ...(details.signals || []),
    ...(details.reachedAt
      ? [{ type: HOT_LIST.SIGNAL_TYPES.REACHED, at: details.reachedAt }]
      : []),
  ];
  return candidates.reduce(
    (latest, signal) =>
      !latest || new Date(signal.at) > new Date(latest.at) ? signal : latest,
    null,
  );
};

const formatAge = (date, now, translate) => {
  const minutes = Math.max(0, Math.round((now - new Date(date)) / MINUTE_MS));
  if (minutes < 1) return translate.JUST_NOW;
  const age =
    minutes < HOUR_MINUTES
      ? translate.MINUTES.replace("{{count}}", minutes)
      : minutes < DAY_MINUTES
        ? translate.HOURS.replace(
            "{{count}}",
            Math.round(minutes / HOUR_MINUTES),
          )
        : translate.DAYS.replace(
            "{{count}}",
            Math.round(minutes / DAY_MINUTES),
          );
  return translate.AGO.replace("{{age}}", age);
};

const useNow = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), MINUTE_MS);
    return () => clearInterval(timer);
  }, []);
  return now;
};

const LastSignal = ({ project, translate, labels }) => {
  const now = useNow();
  const signal = latestSignal(project);
  const label = signal
    ? get(labels, signal.type, signal.type)
    : translate.ARRIVED;
  const date = signal ? signal.at : get(project, "createdDate");
  if (!date) return null;
  return (
    <div className="last-signal">
      <span className="last-signal__label">{label}</span>
      <span className="last-signal__age">
        {` · ${formatAge(date, now, translate)}`}
      </span>
    </div>
  );
};

LastSignal.propTypes = {
  project: PropTypes.object.isRequired,
  translate: PropTypes.object.isRequired,
  labels: PropTypes.object,
};

LastSignal.defaultProps = {
  labels: {},
};

export default LastSignal;
